import React, { FC, ReactNode } from 'react';

import { SerializedStyles } from '@emotion/react';

import styled from '../styled';

interface IRatio {
  ratio?: number;
  children: ReactNode;
  contentWrapperClass?: string;
  contentWrapperCss?: SerializedStyles;

  [key: string]: any;
}

const Ratio: FC<IRatio> = ({
  ratio = 56,
  children,
  contentWrapperClass = '',
  contentWrapperCss,
  ...rest
}) => {
  return (
    <Wrapper {...rest}>
      <RatioSpace ratio={ratio} />
      <Content className={contentWrapperClass} optionalStyles={contentWrapperCss}>
        {children}
      </Content>
    </Wrapper>
  );
};

export default Ratio;

const Content = styled('div', {
  shouldForwardProp: (prop) => prop !== 'optionalStyles',
})`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  ${({ optionalStyles }) => optionalStyles}
`;
const RatioSpace = styled('div')(({ ratio }: { ratio: number }) => ({
  width: '100%',
  paddingTop: ratio + '%',
}));

const Wrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'hideVideoIframe',
})({
  position: 'relative',
  width: '100%',
});
